import axios from "axios";
import router from "../router/index";
import $ from "jquery";
import { Message } from "element-ui";
import Vue from "vue";
const organization = {
  state: () => ({
    bankList: [],
    organizationList: [],
    currentOrganization: {},
    validationErrors: [],
    organizationTeamContent: null,
    allRoles: [],
    attendeeList: {
      attendees: [],
      total: 0
    },
    applicationList: [],
    organizationRole: null
  }),
  mutations: {
    setBankList(state, payload) {
      state.bankList = payload.items;
    },
    setWhiteLabelApplicationList(state, payload) {
      state.applicationList = payload.items;
    },
    setOrganizationRole(state, payload) {
      state.organizationRole = payload;
    },
    setOrganizationList(state, payload) {
      state.organizationList = payload;
    },
    setCurrentOrganization(state, payload) {
      state.currentOrganization = payload;
    },
    setOrganizationValidationErrors(state, payload) {
      state.validationErrors = payload;
    },
    setTeamContent(state, payload) {
      var dummy = JSON.parse(JSON.stringify(payload));
      dummy.users = dummy.users.map(x => {
        x = {
          ...x,
          show: false
        };
        return x;
      });
      state.organizationTeamContent = dummy;
    },
    setLoadAllRoles(state, payload) {
      state.allRoles = payload;
    },
    setAttendeList(state, payload) {
      state.attendeeList = payload;
    }
  },
  actions: {
    async organizationDelete(store, payload) {
      var res = await axios.post("Organization/DeleteOrganization", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async getWhiteLabelUserApplications(store, payload) {
      var res = await axios.post("Organization/GetUserWhitelabelApplications", {});
      store.commit("setWhiteLabelApplicationList", res.data.data);
      return res;
    },
    async deleteEvent(store, payload) {
      var res = await axios.post("Organization/DeleteEvent", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async archiveEvent(store, payload) {
      var res = await axios.post("Organization/ToggleEventIsArchived", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async copyEvent(store, payload) {
      var res = await axios.post("Organization/CopyEvent", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async testGetPaymentInfo(store, payload) {
      var res = await axios.post("Organization/GetPaymentInfo", { orderNumber: payload });
      return res;
    },
    async tryPaymentMethod(store, payload) {
      var res = await axios.post("Organization/TrySamplePayment", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async deletePaymentProviders(store, payload) {
      var res = await axios.post("Organization/DeletePaymentProvider", { posId: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async getPaymentProvider(store, payload) {
      var res = await axios.post("Organization/GetPaymentProvider", { posId: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async addUpdateBank(store, payload) {
      var res = await axios.post("Organization/AddUpdatePaymentProvider", payload);
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        Message.success(res.data.alert.message);
      }
      return res;
    },
    async getBanks(store) {
      var res = await axios.post("Organization/GetBanks ", { skip: 0, take: 1000 });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      } else {
        store.commit("setBankList", res.data.data);
      }
      return res;
    },
    async getBankParameters(store, payload) {
      var res = await axios.post("Organization/GetBankParameters ", { bankId: payload, skip: 0, take: 1000 });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async getRoleOrg(context, payload) {
      var res = await axios.post("/Role/Get", { id: payload });
      if (res.data.alert.hasError) {
        Message.error(res.data.alert.message);
        return;
      }
      return res.data.data.item;
    },
    async getAttendeeList(context, payload) {
      var res = await axios.post("/Organization/Attendees", payload);
      if (!res.data.alert.hasError) {
        context.commit("setAttendeList", res.data.data);
      } else {
        Message.error(res.data.alert.message);
      }
    },
    async getLoadAllRoles(context) {
      var res = await axios.post("/Role/LoadAllRoles", { skip: 0, take: 1000 });
      if (!res.data.alert.hasError) {
        context.commit("setLoadAllRoles", res.data.data.items);
      } else {
        Message.error(res.data.alert.message);
      }
    },

    async deleteMemberFromTeam(context, payload) {
      var res = await axios.post("/Organization/DeleteMemberFromTeam", { id: payload });
      if (!res.data.alert.hasError) {
        Message.success(res.data.alert.message);
        context.dispatch("getOrganizationTeamContent");
      } else {
        Message.error(res.data.alert.message);
      }
    },
    async toggleMemberIsActive(context, payload) {
      var res = await axios.post("/Organization/ToggleMemberIsActive", { id: payload });
      if (!res.data.alert.hasError) {
        Message.success(res.data.alert.message);
        context.dispatch("getOrganizationTeamContent");
      } else {
        Message.error(res.data.alert.message);
      }
    },
    async addUpdateTeamMember(context, payload) {
      var res = await axios.post("/Organization/AddUpdateMember", payload);
      context.commit("setOrganizationValidationErrors", res.data.validationErrors);
      if (!res.data.alert.hasError) {
        Message.success(res.data.alert.message);
        context.dispatch("getOrganizationTeamContent");
      } else {
        Message.error(res.data.alert.message);
      }
      return res;
    },
    async getOrganizationTeamContent(context) {
      var res = await axios.post("/Organization/LoadTeam");

      if (!res.data.alert.hasError) {
        if (res.data.data.users.length > 0) {
          res.data.data.users = res.data.data.users.map(x => {
            return {
              ...x,
              image: x.image.replaceAll("https://img.imageus.dev/", "")
            };
          });
        }
        context.commit("setTeamContent", res.data.data);
      } else {
        Message.error(res.data.alert.message);
      }
    },
    async createOrganizationEvent(store, payload) {
      var res = await axios.post("/Organization/CreateEvent", { title: payload });
      return res;
    },
    async getOrganizationList(context) {
      var res = await axios.post("/Organization/GetAuthorizedOrganizations", {});

      if (!res.data.alert.hasError) {
        context.commit("setOrganizationList", res.data.data.organizations);
      } else {
        Message.error(res.data.alert.message);
      }
    },
    async getOrganization(context) {
      var res = await axios.post("/Organization/GetOrganization", {});

      if (!res.data.alert.hasError) {
        if (res.data.data.item.instagram != null) {
          res.data.data.item.instagram = res.data.data.item.instagram.replaceAll("https://www.instagram.com/", "");
        }
        if (res.data.data.item.twitter != null) {
          res.data.data.item.twitter = res.data.data.item.twitter.replaceAll("https://www.twitter.com/", "");
        }
        if (res.data.data.item.linkedIn != null) {
          res.data.data.item.linkedIn = res.data.data.item.linkedIn.replaceAll("https://www.linkedin.com/", "");
        }
        if (res.data.data.item.facebook != null) {
          res.data.data.item.facebook = res.data.data.item.facebook.replaceAll("https://www.facebook.com/", "");
        }
        if (res.data.data.item.youtube != null) {
          res.data.data.item.youtube = res.data.data.item.youtube.replaceAll("https://www.youtube.com/", "");
        }
        if (res.data.data.item.website != null) {
          res.data.data.item.website = res.data.data.item.website.replaceAll("https://", "");
        }
        context.commit("setOrganizationRole", res.data.data.role);
        context.commit("setCurrentOrganization", res.data.data.item);
      } else {
        Message.error(res.data.alert.message);
      }
    },
    async updateOrganizationProfile(context, payload) {
      var pClone = JSON.parse(JSON.stringify(payload));
      if (pClone.location.latitude != null && pClone.location.longtitude != null) {
        pClone.location.latitude = pClone.location.latitude.toString();
        pClone.location.longtitude = pClone.location.longtitude.toString();
      }
      context.commit("setOrganizationValidationErrors", []);
      var res = await axios.post("/Organization/UpdateOrganizationProfile", pClone);
      context.commit("setOrganizationValidationErrors", res.data.validationErrors);
      if (!res.data.alert.hasError) {
        Message.success(res.data.alert.message);
        context.dispatch("getOrganization");
        context.dispatch("getOrganizationList");
      } else {
        Message.error(res.data.alert.message);
      }
    },
    async createOrganization(context, payload) {
      var res = await axios.post("/Organization/CreateOrganization", payload);
      if (!res.data.alert.hasError) {
        context.dispatch("getOrganizationList");
      }
      return res;
    }
  },
  getters: {
    getOrganizationRole: state => state.organizationRole,
    getOrganizationList: state => state.organizationList,
    getCurrentOrganization: state => state.currentOrganization,
    getOrganizationValidationErrors: state => state.validationErrors,
    getOrganizationTeamContent: state => state.organizationTeamContent,
    getLoadAllRoles: state => state.allRoles,
    getAttendeeList: state => state.attendeeList,
    getBankList: state => state.bankList,
    getWhiteLabelApplicationList: state => state.applicationList
  }
};
export default organization;



// WEBPACK FOOTER //
// ./src/store/organization.js